<template>
    <vs-popup id="confirm-payroll-popup" class="confirm-payroll-popup" title="Create Payroll" :active.sync="popupConfirmPayroll.isOpen">
        <div v-if="approvePayrollData && approvePayrollData.length > 0">
            <div class="top-color"></div>
            <div class="flex-center flex-col">
                <img src="../../assets/images/payroll-confirm-img.png" class="mt-base pt-3 confirm-img" />
                <p class="font-bold color-black confirm-text text-center mt-6">Are you sure to confirm this payroll?</p>
                <p class="text-xl font-bold color-black mt-base">
                    {{getDuration(approvePayrollData[0].start_date, approvePayrollData[0].end_date)}}
                    <span v-if="getDuration(approvePayrollData[0].start_date, approvePayrollData[0].end_date) > 1">days</span>
                    <span v-else>day</span>
                </p>
                <p class="text-xl font-bold color-black mt-2">{{changeFormat(approvePayrollData[0].start_date)}}   -   {{changeFormat(approvePayrollData[0].end_date)}}</p>
                <div class="text-center note-content mt-6">
                    Note: After the payroll is confirmed, all 
                    transactions in that payroll can not be 
                    changed
                </div>
                <div class="w-full flex-center pt-5 pb-6">
                    <div class="w-1/3 pr-4">
                        <vs-button class="w-full cancel-btn" color="white" @click="closePopup">CANCEL</vs-button>
                    </div>
                    <div class="w-1/3 pl-4">
                        <vs-button class="w-full ok-btn" @click="saveConfirm">OK</vs-button>
                    </div>
                </div>
            </div>
        </div>
    </vs-popup>
</template>

<script>
import moment from 'moment';
import { changeFormatHelper } from '../../helper/datetimeHelper';
export default {
    name: 'confirm-payroll-popup',
    props: {
        popupConfirmPayroll: {
            type: Object,
            required: true
        }
    },
    data() {
        return {

        }
    },
    methods: {
        closePopup() {
            this.$emit('closePopup');
        },
        saveConfirm() {
            this.$emit('saveConfirm');
        },
        changeFormat(date) {
            if(date) {
                return changeFormatHelper(date);
            } else {
                return 'N/A';
            }
        },
        getDuration(from, to) {
            if(from && to) {
                return moment(to).diff(moment(from), 'days') + 1;
            }
            return 0;
        }
    },
    computed: {
        approvePayrollData() {
            return this.$store.getters["goPos/approvePayrollData"];
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables.scss";
.con-vs-popup {
    &.confirm-payroll-popup {
        z-index: 99999;
        .vs-popup {
            width: 420px;
            height: auto;
            .vs-popup--header {
                display: none;
            }
            .vs-popup--content {
                width: auto;
                // height: 500px;
                margin: 0;
                padding: 0;
                border-radius: 5px;

                .top-color {
                    width: 100%;
                    height: 11px;
                    background: $primary;
                }

                .confirm-img {
                    width: 25%;
                }
                
                .confirm-text {
                    font-size: 1.6rem;
                    padding: 0 65px;
                }

                .note-content {
                    font-size: 1.1rem;
                    padding: 10px 40px;
                    background: #FDF7E8;
                }

                .vs-button {
                    border-radius: 10px;
                    .vs-button--text {
                        font-weight: bold;
                    }
                }

                .cancel-btn {
                    box-shadow: 0px 2px 5px rgba(#AAAAAA, 0.7) !important;
                    .vs-button--text {
                        color: #5B94E2;
                    }
                }

                .ok-btn {
                    box-shadow: 0px 2px 5px rgba($primary, 0.7);
                }
            }
        }
    }
}
</style>